import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {IconButton} from '@mui/material';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';

import InvertColorsIcon from '@mui/icons-material/InvertColors';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import HearingIcon from '@mui/icons-material/Hearing';

export default function SimpleMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton aria-controls="simple-menu" onClick={handleClick}>
                <AccessibilityNewIcon/>
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}><InvertColorsIcon/></MenuItem>
                <MenuItem onClick={handleClose}><FormatSizeIcon/></MenuItem>
                <MenuItem onClick={handleClose}><HearingIcon/></MenuItem>
            </Menu>
        </>
    );
}
